import { render, staticRenderFns } from "./DSSummaryCard.vue?vue&type=template&id=40ee8c9f&"
import script from "./DSSummaryCard.vue?vue&type=script&lang=js&"
export * from "./DSSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports